import { CommonService, RepairOrderQuoteSubmitModel } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type UpdateCdkMileageInput = {
  vin: string;
  mileage: number;
};

export const useCommonUpdateCdkMileageMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.postCommonFindVehicleAndUpdateCdkMileage>>,
      QueryError,
      UpdateCdkMileageInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ vin, mileage }: UpdateCdkMileageInput) => {
      return CommonService.postCommonFindVehicleAndUpdateCdkMileage(vin, mileage);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated Mileage!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
